import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';

import { orderedCoreSuperBatchModulesSelector } from 'features/moduleManagement';
import ErrorLayout from 'components/ErrorLayout';
import SuperBatchModulesDragDrop from '../SuperBatchModulesDragDrop';
import SuperBatchModulesTableHeader from '../SuperBatchModulesTableHeader';
import SuperBatchModulesTableRow from '../SuperBatchModulesTableRow';
import styles from './SuperBatchModulesTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function SuperBatchModulesTable() {
  const orderedCoreMenteeModules = useSelector(
    orderedCoreSuperBatchModulesSelector
  );

  if (orderedCoreMenteeModules.length > 0) {
    return (
      <SuperBatchModulesDragDrop
        orderedCoreMenteeModules={orderedCoreMenteeModules}
      >
        <Table className={styles.table}>
          <SuperBatchModulesTableHeader />
          <Droppable droppableId="mentee-modules">
            {({ innerRef, droppableProps, placeholder: dropPlaceholder }) => (
              <TableBody
                ref={innerRef}
                {...droppableProps}
              >
                {orderedCoreMenteeModules.map((superBatchModule, index) => (
                  <SuperBatchModulesTableRow
                    superBatchModule={superBatchModule}
                    key={superBatchModule.id}
                    index={index}
                  />
                ))}
                {dropPlaceholder}
              </TableBody>
            )}
          </Droppable>
        </Table>
      </SuperBatchModulesDragDrop>
    );
  }

  return <ErrorLayout message="This super batch does not have any modules." />;
}

export default SuperBatchModulesTable;
